module.exports = __webpack_public_path__ + "img/logo.e4405811.svg";